import React from 'react';
import setupDataFetcher from 'hooks/setupDataFetcher';
import { Market, UseMarkets } from './types';

function useMarkets({ disabled = false } = {}): UseMarkets {
  const [data, setData] = React.useState<Array<Market>>([]);
  const [loading, setLoading] = React.useState<boolean>(true);
  const [error, setError] = React.useState<boolean>(false);
  const disposer = React.useRef(() => {});

  const setupMarketsFetcher = () => {
    setData([]);
    setLoading(true);
    setError(false);

    const onResult = message => {
      setData(message);
      setLoading(false);
      setError(false);
    };
    const onError = message => {
      console.error(message);
      setError(true);
      setLoading(false);
      disposer.current?.();
    };

    // eslint-disable-next-line no-shadow
    const generateFetchKey = ({ disabled = false } = {}) => `markets${disabled ? '-all' : ''}`;

    disposer.current = setupDataFetcher({
      onResult,
      onError,
      generateFetchKey,
      maxDataAge: 60000, // 1 mins
      propParams: { disabled }
    }).disposer;
  };

  React.useEffect(() => {
    setupMarketsFetcher();
    return () => disposer.current?.();
  }, []);

  const refetch = () => {
    disposer.current?.();
    setupMarketsFetcher();
  };

  return {
    data,
    loading,
    error,
    refetch
  };
}

export default useMarkets;
